export default function home_videos() {
	
  $('.block-videos .videos-list').slick({
    centerMode: true,
    slidesToShow: 1,
    centerPadding: '25vw',
    prevArrow: '<i class="slick-nav-prev fal fa-chevron-left"></i>',
    nextArrow: '<i class="slick-nav-next fal fa-chevron-right"></i>'
  });

  $('.block-videos .videos-list .item a').magnificPopup({
    disableOn: 700,
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: true,
    closeOnBgClick: false
  });
	
}